import { BaseModel } from '~/models/baseModel';

export class ShearingTimesModel extends BaseModel {
    public start:string;
    public end:string;
}
